module.exports = __webpack_public_path__ + "static/media/partager-cercle.df8e70b1.png";